// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "bundle.e37fc1b05bd2dfe9e633e47babc5f510.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "3aa64bef0bffbd8ee6abb9f68f2be774" + ".css";
};